/**
 * Number / currency / date formatting helpers (Italian locale).
 */

export const fmtEur = (n, withDecimals = true) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const num = Number(n);
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: withDecimals ? 2 : 0,
  }).format(num);
};

export const fmtEurInt = (n) => fmtEur(n, false);

export const fmtNum = (n, decimals = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(n));
};

export const fmtDate = (iso, opts = { day: "2-digit", month: "long", year: "numeric" }) => {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    if (isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("it-IT", opts);
  } catch {
    return String(iso);
  }
};

export const fmtDateShort = (iso) => fmtDate(iso, { day: "2-digit", month: "2-digit", year: "numeric" });
